import { convertImageFromDto } from "@modules/dtos/imageDto"
import { type BadgeDto } from "@modules/profile/publicProfile/gateway/publicProfileDto"
import { type HUImage } from "@modules/types/imageTypes"

export class BadgeEntity {
  id: string
  name: string
  code: string
  date: Date
  obtainable: boolean
  image: HUImage

  private constructor(entity: BadgeEntity) {
    this.id = entity.id
    this.name = entity.name
    this.code = entity.code
    this.date = entity.date
    this.obtainable = entity.obtainable
    this.image = entity.image
  }

  static fromDto(dto: BadgeDto): BadgeEntity {
    return new BadgeEntity({
      id: dto.id,
      name: dto.name,
      code: dto.code,
      date: new Date(dto.date),
      obtainable: dto.obtainable,
      image: convertImageFromDto(dto.image),
    })
  }
}
